/**
 * @prettier
 */
document.addEventListener('DOMContentLoaded', () => {
  $('.js-footer-nav-column-title').on('click', e => {
    const $container = $(e.target).closest('.js-footer-nav-column')

    $('.js-footer-nav-column').not($container).removeClass('is-open')
    $container.toggleClass('is-open')
  })
})
